const dic = JSON.parse(localStorage.dic);
export const policyStatus = dic['POLICY_STATUS']; // 保单状态
export const currencyType = dic['CURRENCY_TYPE'];

const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}') || {};
function getCurrencyDesc(code) {
  return currencyType[code] || '';
}
export const config = {
  mixins: [],
  data() {
    return {
      columns: []
    };
  },
  methods: {
    // 获取表格列
    getColumns(s) {
      let columns = [
        {
          title: '保单编号',
          slot: 'policyNo',
          align: 'center',
          width: 150,
          fixed: 'left'
        },
        {
          title: '保单状态',
          key: 'policyStatus',
          align: 'center',
          width: 120,
          render(h, params) {
            return <span>{policyStatus[params.row.policyStatus]}</span>;
          }
        },
        {
          title: '续费年度',
          key: 'renewalYear',
          align: 'center',
          width: 100
        },
        {
          title: '当前进度',
          key: 'renewalState',
          align: 'center',
          width: 140,
          render(h, params) {
            switch (params.row.renewalState * 1) {
              case 0:
                return <Tag color="blue">未缴费</Tag>;
              case 1:
                return <Tag color="blue">未缴费</Tag>;
              case 2:
                return <Tag color="orange">已添加对账申请</Tag>;
              case 3:
                return <Tag color="orange">已提交保司对账</Tag>;
              case 4:
                return <Tag color="orange">保司已入账</Tag>;
              case 5:
                return <Tag color="green">续期成功</Tag>;
              case 6:
                return <Tag color="red">保费逾期</Tag>;
              case 7:
                return <Tag color="red">已失效</Tag>;
              default:
                return <div>-</div>;
            }
          }
        },
        {
          title: '归属人',
          align: 'center',
          key: 'orgName',
          minWidth: 140,
          render(h, params) {
            return <span>{params.row.orgName || ''}</span>;
          }
        },
        {
          title: '保险公司',
          key: 'companyName',
          align: 'center',
          width: 100
        },
        {
          title: '产品名称',
          key: 'productName',
          align: 'center',
          minWidth: 160
        },
        {
          title: '投保人',
          key: 'name',
          align: 'center',
          width: 100
        },
        {
          title: '保单生效日期',
          key: 'effectDate',
          align: 'center',
          width: 130,
          render(h, params) {
            return <div>{params.row.effectDate.substr(0, 10)}</div>;
          }
        },
        {
          title: '当期应缴保费（D）',
          key: 'duePremium',
          align: 'center',
          width: 160,
          render(h, params) {
            return (
              <div>
                {params.row.duePremium} {getCurrencyDesc(params.row.dueCurrency)}
              </div>
            );
          }
        }
      ];
      // if (s != 1) {
      //   columns = columns.concat([
      //     {
      //       title: '当期实际已缴费（E）',
      //       key: 'paidPremium',
      //       align: 'center',
      //       width: 160,
      //       render(h, params) {
      //         return (
      //           <div>
      //             {params.row.paidPremium} {getCurrencyDesc(params.row.paidCurrency)}
      //           </div>
      //         );
      //       }
      //     }
      //   ]);
      // }

      columns = columns.concat([
        {
          title: '当期保费到期日',
          key: 'policyExpireDate',
          align: 'center',
          width: 130,
          render(h, params) {
            return <div>{params.row.policyExpireDate.substr(0, 10)}</div>;
          }
        },
        {
          title: '最新保费到期日',
          key: 'expireDate',
          align: 'center',
          width: 130,
          render(h, params) {
            return <div>{params.row.expireDate.substr(0, 10)}</div>;
          }
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
          width: 100,
          fixed: 'right'
        }
      ]);
      this.columns = columns;
    }
  }
};
